import * as RootNavigation from '../navigation/RootNavigation';
import RouteKeys from '../navigation/RouteKeys';
import { getGlobalState, setGlobalState, STATE_KEYS } from '../configs/config_state';
import { goSwitchAccount } from './util_main_app';
import { showAlert } from './util_helpers';
import { cloneDeep } from 'lodash';

function executeOpenForCatering(dataID = -1, onlyOpenCateringTab = true, isHood = false, isPast = false) {
    RootNavigation.jumpTo(RouteKeys.CATERING_STACK);
    const currentData = cloneDeep(getGlobalState(STATE_KEYS.DEEP_LINK_DATA_CATERING));
    if (onlyOpenCateringTab || isPast) {
        if (isHood || isPast) {
            setGlobalState(STATE_KEYS.DEEP_LINK_DATA_CATERING, { ...currentData, goTo: `${isHood ? 'hood' : 'catering'}-reminder${isPast ? '-past' : ''}` });
        }
    }
    else {
        setGlobalState(STATE_KEYS.DEEP_LINK_DATA_CATERING, { ...currentData, openDetails: { dataID, isHood } });
    }
}

export function processDeepLink({ params = {}, path = '' }) {
    // If deep link here is no link
    if (!params || !Object.keys(params).length) {
        console.log('[DEEP LINK] No deep link params');
        return;
    }

    // Deconstruct params
    const { truckID, catering, hood } = cloneDeep(params || {});

    // Reset deep link configs
    setGlobalState(STATE_KEYS.DEEP_LINK_DATA, {});

    // Start navigating
    const routeName = (path.replace('/?', '').split('&')[0] || '').split('=')[0] || '';
    console.log('[DEEP LINK] Route Name', routeName);
    switch(routeName) {
        case 'account-settings': {
            RootNavigation.jumpTo(RouteKeys.ACCOUNT_SETTINGS_STACK);
            break;
        }
        case 'subscription-settings':
        case 'payment-settings':
        {
            RootNavigation.jumpTo(RouteKeys.ACCOUNT_SETTINGS_STACK);
            setTimeout(() => RootNavigation.setParams(RouteKeys.ACCOUNT_SETTINGS, { goTo: routeName }), 250);
            break;
        }
        case 'profile-tab': {
            RootNavigation.jumpTo(RouteKeys.PROFILE_STACK);
            setTimeout(() => RootNavigation.pop(true), 250);
            break;
        }
        case 'edit-profile':
        case 'edit-schedule':
        case 'all-reviews': {
            RootNavigation.jumpTo(RouteKeys.PROFILE_STACK);
            setTimeout(() => {
                RootNavigation.pop(true);
                RootNavigation.setParams(getGlobalState(STATE_KEYS.PROFILE_SCREEN_KEY), { goTo: routeName });
            }, 250);
            break;
        }
        case 'order-tab':
        {
            RootNavigation.jumpTo(RouteKeys.ORDER_STACK);
            break;
        }
        case 'dashboard-tab':
        {
            RootNavigation.jumpTo(RouteKeys.DASHBOARD_STACK);
            break;
        }
        case 'more-tab':
        {
            RootNavigation.jumpTo(RouteKeys.MORE_STACK);
            break;
        }
        case 'past-hood':
        case 'past-catering':
        case 'hood-reminder':
        case 'catering-reminder':
        case 'catering':
        case 'hood':
        {
            const dataID = Number(catering || hood || 0);

            // Handle multiple trucks
            const globalTruckData = getGlobalState(STATE_KEYS.TRUCK_DATA);
            const accountList = getGlobalState(STATE_KEYS.ACCOUNT_LIST);
            if ((truckID !== globalTruckData.id) && (!routeName.includes('past') && !routeName.includes('remind'))) {
                const accountIndex = accountList.findIndex((account) => account.data.trucks[0].id === Number(truckID));
                if (accountIndex > -1) {
                    goSwitchAccount(accountList[accountIndex], accountIndex);
                    setTimeout(() => executeOpenForCatering(dataID, false, routeName.includes('hood')), 500 /* Wait time for global token to update */);
                }
                else {
                    showAlert({ text: `This ${routeName.includes('hood') ? 'hood' : 'catering'} event does not belong to your truck (Event ID: ${dataID}).\n\nIf you believe this is not correct, please contact us at vendor.support@gotruckster.com.` });
                }
            }
            else {
                executeOpenForCatering(dataID, routeName.includes('remind'), routeName.includes('hood'), routeName.includes('past'));
            }
            break;
        }
        default: {
            break;
        }
    }
}
